import { useHistory } from 'react-router'
import React from 'react'

import { usePersistedState } from 'hooks'
import { entities } from 'reduxStore'

import { EditedJobPost } from 'components/EditPost'
import Dates from 'components/EditPost/Dates'

export default function EditJobPostDates() {
	const history = useHistory()
	const { mode }: { mode: 'post' | 'edit' } = history.location.state as any

	const [persistedJob, saveJob] = usePersistedState({
		entityName: entities.editedJobPost,
		initialValue: {} as EditedJobPost,
	})

	return (
		<Dates
			mode={mode}
			initEndDate={persistedJob.endDate}
			initStartDate={persistedJob.startDate}
			initBasis={persistedJob.basis}
			isNextAvailable={false}

			onNext={(
				{
					startDate,
					endDate,
					approxStart,
					approxEnd,
				},
			) => {
				saveJob({
					...persistedJob,
					startDate,
					endDate,
					approxStart,
					approxEnd,
				})

				return 'postCandidateRequirements'
			}}
		/>
	)
}
